export function isUndefined(x: unknown): x is undefined {
  return x === undefined;
}
